/**
 * 首页 - WebSocket实时更新版
 * 使用WebSocket接收实时行情推送
 */

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import commonApi from '/src/common/api/common';
import currencyApi from '/src/common/api/currency';
import wsManager from '@/common/websocket/WebSocketManager';
import logger from '@/common/util/logger';
import util from '@/common/util';

import {
    mapState,
    mapGetters,
    mapMutations
} from 'vuex';
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import kline from "@/components/kline/kline.vue";

var currencyDesc;
var currencyASC;
var currencyQuan;
var currencyList;

export default {
    components: {
        PageNav,
        Swiper,
        SwiperSlide,
        Footer,
        kline
    },
    computed: {
        ...mapState(['config', 'userinfo', 'userTheme']),
        ...mapGetters(['isLogin', 'userId']),
        
        customerServiceText() {
            if (this.$t && typeof this.$t === 'function') {
                try {
                    const translated = this.$t('common.customer_service');
                    if (translated === 'common.customer_service') {
                        return this.getCustomerServiceFallback();
                    }
                    return translated;
                } catch (error) {
                    logger.error('❌ 获取客服翻译失败:', error);
                    return this.getCustomerServiceFallback();
                }
            }
            return this.getCustomerServiceFallback();
        }
    },
    data() {
        return {
            modules:[Navigation, Autoplay],
            messiHover: false,
            themeType: false,
            bannerSwiperOption: [
                {
                    cover: require('@/assets/images/home/banner_swiper_bg1.png'),
                    title: 'Welcome to DBG Markets',
                    desc: 'Secure and convenient digital asset trading platform'
                },
                {
                    cover: require('@/assets/images/home/banner_swiper_bg2.png'),
                    title: 'Professional Trading Platform',
                    desc: 'Providing various digital asset trading services'
                },
                {
                    cover: require('@/assets/images/home/banner_swiper_bg3.png'),
                    title: 'Secure and Reliable',
                    desc: 'Multiple security guarantees for worry-free trading'
                }
            ],
            tabOption: [],
            tableColumns: [],
            IndexConfig: {},
            currencyList: [],
            noticeGroup:[],
            allCurrency:[],
            tabActive: 0,
            randName: [],
            isRealTimeEnabled: true,
            lastUpdateTime: 0,
            // WebSocket连接状态
            wsConnected: false,
            customerServiceUrl: '',
            customerServiceConfigRequest: null,
            isOpeningCustomerService: false
        }
    },
    mounted() {
        logger.log('🏠 首页加载 - WebSocket实时更新版');
        
        // 初始化翻译文本
        this.initTranslations();
        
        // 获取初始数据
        this.getTradesCurrency();
        
        // 获取公告
        this.getNotice();

        // 与 H5 在线客服一致，预取第 5 组客服配置中的 zxkf 字段。
        this.loadCustomerServiceUrl();
        
        // 连接WebSocket获取实时行情
        this.connectWebSocket();
    },
    beforeUnmount() {
        logger.log('🧹 首页组件销毁，清理WebSocket资源...');
        
        // 断开WebSocket连接
        wsManager.disconnect('home-trade');
        this.wsConnected = false;
    },
    methods: {
        /**
         * 初始化翻译文本
         */
        initTranslations() {
            // 使用翻译键，如果不存在则使用英文默认值
            const lang = this.$util.getCache('lang', 'en-US');
            
            if (lang === 'zh_CN' || lang === 'zh_Hant') {
                // 中文
                this.tabOption = ['热门', '涨幅榜', '跌幅榜', '成交量'];
                this.tableColumns = ['名称', '最新价', '涨跌幅', '24h成交量', '操作'];
                this.randName = ['每日财富', 'CBUSER-TO1231', '趋势大师', '超级交易员', '一起发财', 'WinMore', '专业比特', 'CBUSER-T1242'];
            } else {
                // 英文及其他语言
                this.tabOption = ['Hot', 'Gainers', 'Losers', 'Volume'];
                this.tableColumns = ['Name', 'Last Price', 'Change', '24h Volume', 'Action'];
                this.randName = ['Daily Fortune', 'CBUSER-TO1231', 'Trend Master', 'Super Trader', 'Get Rich Together', 'WinMore', 'Professional Bit', 'CBUSER-T1242'];
            }
            
            // 轮播图多语言文字
            this.initBannerTranslations(lang);
        },
        
        /**
         * 初始化轮播图多语言文字
         */
        initBannerTranslations(lang) {
            const bannerTexts = {
                'zh_CN': {
                    banner1: { title: '欢迎来到 DBG Markets', desc: '安全便捷的数字资产交易平台' },
                    banner2: { title: '专业交易平台', desc: '提供多种数字资产交易服务' },
                    banner3: { title: '安全可靠', desc: '多重安全保障，让您交易无忧' }
                },
                'zh_Hant': {
                    banner1: { title: '歡迎來到 DBG Markets', desc: '安全便捷的數字資產交易平台' },
                    banner2: { title: '專業交易平台', desc: '提供多種數字資產交易服務' },
                    banner3: { title: '安全可靠', desc: '多重安全保障，讓您交易無憂' }
                },
                'ja': {
                    banner1: { title: 'DBG Markets取引所へようこそ', desc: '安全で便利なデジタル資産取引プラットフォーム' },
                    banner2: { title: 'プロフェッショナル取引プラットフォーム', desc: '多様なデジタル資産取引サービスを提供' },
                    banner3: { title: '安全で信頼性が高い', desc: '多重セキュリティ保障で安心取引' }
                },
                'ko': {
                    banner1: { title: 'DBG Markets 거래소에 오신 것을 환영합니다', desc: '안전하고 편리한 디지털 자산 거래 플랫폼' },
                    banner2: { title: '전문 거래 플랫폼', desc: '다양한 디지털 자산 거래 서비스 제공' },
                    banner3: { title: '안전하고 신뢰할 수 있는', desc: '다중 보안 보장으로 안심 거래' }
                },
                'th': {
                    banner1: { title: 'ยินดีต้อนรับสู่ DBG Markets', desc: 'แพลตฟอร์มซื้อขายสินทรัพย์ดิจิทัลที่ปลอดภัยและสะดวก' },
                    banner2: { title: 'แพลตฟอร์มการซื้อขายระดับมืออาชีพ', desc: 'ให้บริการซื้อขายสินทรัพย์ดิจิทัลหลากหลาย' },
                    banner3: { title: 'ปลอดภัยและเชื่อถือได้', desc: 'การรับประกันความปลอดภัยหลายชั้นสำหรับการซื้อขายที่ไร้กังวล' }
                },
                'ru': {
                    banner1: { title: 'Добро пожаловать в DBG Markets', desc: 'Безопасная и удобная платформа для торговли цифровыми активами' },
                    banner2: { title: 'Профессиональная торговая платформа', desc: 'Предоставление различных услуг по торговле цифровыми активами' },
                    banner3: { title: 'Безопасно и надежно', desc: 'Многоуровневая защита для беззаботной торговли' }
                },
                'gm': {
                    banner1: { title: 'Willkommen bei DBG Markets', desc: 'Sichere und bequeme Handelsplattform für digitale Vermögenswerte' },
                    banner2: { title: 'Professionelle Handelsplattform', desc: 'Bietet verschiedene digitale Asset-Handelsdienste' },
                    banner3: { title: 'Sicher und zuverlässig', desc: 'Mehrfache Sicherheitsgarantien für sorgenfreien Handel' }
                },
                'en-US': {
                    banner1: { title: 'Welcome to DBG Markets', desc: 'Secure and convenient digital asset trading platform' },
                    banner2: { title: 'Professional Trading Platform', desc: 'Providing various digital asset trading services' },
                    banner3: { title: 'Secure and Reliable', desc: 'Multiple security guarantees for worry-free trading' }
                },
                'au': {
                    banner1: { title: 'Welcome to DBG Markets', desc: 'Secure and convenient digital asset trading platform' },
                    banner2: { title: 'Professional Trading Platform', desc: 'Providing various digital asset trading services' },
                    banner3: { title: 'Secure and Reliable', desc: 'Multiple security guarantees for worry-free trading' }
                }
            };
            
            // 获取当前语言的翻译，默认使用英文
            const texts = bannerTexts[lang] || bannerTexts['en-US'];
            
            this.bannerSwiperOption = [
                {
                    cover: require('@/assets/images/home/banner_swiper_bg1.png'),
                    title: texts.banner1.title,
                    desc: texts.banner1.desc
                },
                {
                    cover: require('@/assets/images/home/banner_swiper_bg2.png'),
                    title: texts.banner2.title,
                    desc: texts.banner2.desc
                },
                {
                    cover: require('@/assets/images/home/banner_swiper_bg3.png'),
                    title: texts.banner3.title,
                    desc: texts.banner3.desc
                }
            ];
        },
        
        /**
         * 连接WebSocket获取实时行情
         */
        connectWebSocket() {
            logger.log('🔌 首页连接WebSocket...');
            
            wsManager.connect('trade', {
                onMessage: this.handleWebSocketMessage,
                onOpen: () => {
                    logger.log('✅ 首页WebSocket连接成功');
                    this.wsConnected = true;
                },
                onError: (error) => {
                    logger.error('❌ 首页WebSocket连接错误:', error);
                    this.wsConnected = false;
                },
                onClose: () => {
                    logger.log('🔌 首页WebSocket连接关闭');
                    this.wsConnected = false;
                },
                userId: this.isLogin ? this.userId : null,
                enableHeartbeat: true,
                enableUserIdUpdate: this.isLogin
            });
        },
        
        /**
         * 处理WebSocket消息
         */
        handleWebSocketMessage(data) {
            if (!data || !data.type) return;
            
            // type 100: ticker数据(价格更新)
            if (data.type === 100 && data.data && data.data.data) {
                this.updateCurrencyPrices(data.data.data);
            }
        },
        
        /**
         * 更新币种价格
         */
        updateCurrencyPrices(tickerData) {
            if (!this.allCurrency || this.allCurrency.length === 0) return;
            
            let updateCount = 0;
            
            // 遍历所有币种，更新价格
            this.allCurrency.forEach((currency, index) => {
                const ticker = util.getCurrentTicker(currency.id, tickerData);
                if (ticker && ticker.c) {
                    // 更新价格数据
                    this.allCurrency[index] = {
                        ...currency,
                        new_price: parseFloat(ticker.c),
                        change_rate: parseFloat(ticker.P),
                        high_price: parseFloat(ticker.h),
                        low_price: parseFloat(ticker.l),
                        quantity: parseFloat(ticker.v),
                        quota: parseFloat(ticker.q)
                    };
                    updateCount++;
                }
            });
            
            if (updateCount > 0) {
                this.lastUpdateTime = Date.now();
                
                // 更新显示列表
                this.updateDisplayList();
                
                // 更新排序数据
                currencyDesc = this.$util.sortDesc(this.allCurrency);
                currencyASC = this.$util.sortAsc(this.allCurrency);
                currencyQuan = this.$util.sortQuan(this.allCurrency);
                
                // 强制更新视图
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
                
                logger.debug(`📈 首页更新了 ${updateCount} 个币种的价格`);
            }
        },
        
        /**
         * 更新显示列表
         */
        updateDisplayList() {
            if (this.tabActive === 0) {
                // 热门 - 显示前10个
                this.currencyList = this.allCurrency.slice(0, 10);
            } else if (this.tabActive === 1) {
                // 涨幅榜
                this.currencyList = this.$util.sortDesc(this.allCurrency).slice(0, 10);
            } else if (this.tabActive === 2) {
                // 跌幅榜
                this.currencyList = this.$util.sortAsc(this.allCurrency).slice(0, 10);
            } else if (this.tabActive === 3) {
                // 成交量榜
                this.currencyList = this.$util.sortQuan(this.allCurrency).slice(0, 10);
            }
        },
        
        /**
         * 切换币种分类
         */
        switchCurrency(index) {
            this.tabActive = index;
            this.updateDisplayList();
        },
        
        /**
         * 获取币种列表(初始数据)
         */
        async getTradesCurrency() {
            try {
                logger.log('📊 获取币种列表...');
                const res = await currencyApi.tradeCurrencyList();
                
                if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                    if (res.data[0] && res.data[0].currency) {
                        this.allCurrency = [...res.data[0].currency];
                        this.currencyList = [...res.data[0].currency.slice(0, 10)];
                        
                        // 保存排序数据
                        currencyList = res.data[0];
                        currencyDesc = this.$util.sortDesc(this.allCurrency);
                        currencyASC = this.$util.sortAsc(this.allCurrency);
                        currencyQuan = this.$util.sortQuan(this.allCurrency);
                        
                        logger.log(`✅ 获取到 ${this.allCurrency.length} 个币种`);
                    }
                } else {
                    logger.warn('⚠️ 币种数据格式不正确');
                }
            } catch (error) {
                logger.error('❌ 获取币种列表失败:', error);
            }
        },
        
        /**
         * 获取轮播图
         */
        async getIndexBanner(retryCount = 0) {
            try {
                const res = await commonApi.getBanner('banner');
                if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                    this.bannerSwiperOption = res.data.map(item => ({
                        cover: item.image || item.cover,
                        title: item.title || '',
                        desc: item.desc || item.description || ''
                    }));
                    logger.log('✅ 轮播图加载成功');
                }
            } catch (error) {
                logger.error('❌ 获取轮播图失败:', error);
                if (retryCount < 2) {
                    setTimeout(() => {
                        this.getIndexBanner(retryCount + 1);
                    }, 2000);
                }
            }
        },
        
        /**
         * 获取公告
         */
        async getNotice() {
            try {
                const res = await commonApi.getNotice();
                if (res && res.data && Array.isArray(res.data)) {
                    this.noticeGroup = res.data;
                    logger.log('✅ 公告加载成功');
                }
            } catch (error) {
                logger.error('❌ 获取公告失败:', error);
            }
        },

        /**
         * 首页主入口根据当前登录状态进入行情或登录页。
         */
        goToQuotesOrLogin() {
            this.$router.push(this.isLogin ? '/quotes' : '/login');
        },
        
        /**
         * 跳转到交易页面
         */
        goToTrade(currency) {
            if (!currency || !currency.id) {
                logger.warn('⚠️ 币种信息不完整');
                return;
            }
            
            logger.log('🎯 跳转到现货交易:', currency.symbol);
            this.$util.setCache('trade-current', JSON.stringify(currency));
            this.$router.push({
                path: '/spot',
                query: { currency_id: currency.id }
            });
        },
        
        /**
         * 打开在线客服
         */
        async openCustomerService() {
            if (this.isOpeningCustomerService) {
                return;
            }

            this.isOpeningCustomerService = true;
            try {
                const configuredUrl = this.getCustomerServiceUrl(this.$store.state.config);

                if (this.isExternalCustomerServiceUrl(configuredUrl)) {
                    this.openCustomerServiceWindow(configuredUrl);
                    logger.log('✅ 客服页面已打开');
                    return;
                }

                // 在用户点击期间预先打开标签页，避免异步配置请求被浏览器当作弹窗拦截。
                const customerServiceWindow = window.open('', '_blank');
                if (customerServiceWindow) {
                    customerServiceWindow.opener = null;
                }

                const kefuUrl = await this.loadCustomerServiceUrl();
                if (this.isExternalCustomerServiceUrl(kefuUrl)) {
                    if (customerServiceWindow) {
                        customerServiceWindow.location.replace(kefuUrl);
                    } else {
                        this.openCustomerServiceWindow(kefuUrl);
                    }
                    logger.log('✅ 客服页面已打开');
                    return;
                }

                if (customerServiceWindow) {
                    customerServiceWindow.close();
                }
                this.$message.warning(this.$t('common.customer_service_not_configured'));
                logger.warn('⚠️ 客服链接未配置');
            } catch (error) {
                logger.error('❌ 打开客服失败:', error);
                this.$message.error(this.$t('common.failed'));
            } finally {
                this.isOpeningCustomerService = false;
            }
        },

        getCustomerServiceUrl(config) {
            const url = config?.zxkf || config?.kefu_url;
            return typeof url === 'string' ? url.trim() : '';
        },

        isExternalCustomerServiceUrl(url) {
            return /^https?:\/\/\S+$/i.test(url);
        },

        openCustomerServiceWindow(url) {
            const customerServiceWindow = window.open(url, '_blank');
            if (customerServiceWindow) {
                customerServiceWindow.opener = null;
            }
        },

        loadCustomerServiceUrl() {
            if (this.customerServiceUrl) {
                return Promise.resolve(this.customerServiceUrl);
            }

            if (!this.customerServiceConfigRequest) {
                this.customerServiceConfigRequest = commonApi.config(5)
                    .then((res) => {
                        this.customerServiceUrl = this.getCustomerServiceUrl(res?.data);
                        return this.customerServiceUrl;
                    })
                    .catch((error) => {
                        logger.warn('⚠️ 获取客服配置失败:', error);
                        return '';
                    })
                    .finally(() => {
                        this.customerServiceConfigRequest = null;
                    });
            }

            return this.customerServiceConfigRequest;
        },
        
        /**
         * 获取客服文本备用方案
         */
        getCustomerServiceFallback() {
            const lang = this.$util.getCache('lang', 'en-US');
            const customerServiceTexts = {
                'zh_CN': '在线客服',
                'zh_Hant': '在線客服',
                'ja': 'オンラインサポート',
                'ko': '온라인 고객 서비스',
                'en-US': 'Customer Service',
                'th': 'บริการลูกค้า',
                'ru': 'Служба поддержки',
                'gm': 'Kundenservice',
                'au': 'Customer Service'
            };
            return customerServiceTexts[lang] || 'Customer Service';
        },
        
        /**
         * 获取本地化标题
         */
        getLocalizedTitle(title) {
            if (!title) return '';

            // 如果是字符串，直接返回
            if (typeof title === 'string') {
                return title;
            }

            // 如果是对象，尝试解析多语言
            if (typeof title === 'object') {
                try {
                    // 如果是JSON字符串，先解析
                    if (typeof title === 'string' && title.startsWith('{')) {
                        title = JSON.parse(title);
                    }

                    // 获取当前语言
                    const currentLang = this.$i18n?.locale || 'en-US';

                    // 根据当前语言返回对应文本
                    if (currentLang === 'zh_CN') {
                        return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                    } else if (currentLang === 'zh_Hant') {
                        return title['zh_Hant'] || title['zh_CN'] || title['en-US'] || '加密货币';
                    } else if (currentLang === 'en-US') {
                        return title['en-US'] || title['zh_CN'] || title['zh_Hant'] || 'Crypto';
                    } else {
                        // 默认返回中文
                        return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                    }
                } catch (error) {
                    logger.warn('⚠️ 解析多语言标题失败:', error);
                    return '加密货币';
                }
            }

            return '加密货币';
        },
        
        /**
         * Swiper滑动事件
         */
        slideChange(e) {
            this.activeIndex = e.activeIndex;
        }
    }
}
